import { render } from "./AreaListStandard.vue?vue&type=template&id=67beacdc&scoped=true"
import script from "./AreaListStandard.vue?vue&type=script&lang=js"
export * from "./AreaListStandard.vue?vue&type=script&lang=js"

import "./AreaListStandard.vue?vue&type=style&index=0&id=67beacdc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67beacdc"]])

export default __exports__